import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const api_url = process.env.REACT_APP_API_URL;


function Footer() {
    const [ContactDetail, setContactDetail] = useState([]);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 100) {
                setVisible(true);
            } else {
                setVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);

        // Check scroll position on mount
        toggleVisibility();

        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth', // smooth scroll effect
        });
    };


    // Fetch slider data from the API
    useEffect(() => {
        const fetchContactDetail = async () => {
            try {
                const response = await axios.get(`${api_url}/contact_details.php`);
                setContactDetail(response.data);  // Save the fetched data in state
            } catch (error) {
                console.error("Error fetching sliders:", error);
            }
        };

        fetchContactDetail();
    }, []);

    return (
        <>
            {/* <!-- Footer Start --> */}
            <div className="container-fluid bg-dark text-light footer pt-5 mt-5 wow fadeIn" data-wow-delay="0.1s">
                <div className="container py-5">
                    <div className="row g-5">
                        <div className="col-lg-3 col-md-6">
                            <h4 className="text-white mb-3">Quick Link</h4>
                            <Link className="btn btn-link" to="/about">About Us</Link>
                            <Link className="btn btn-link" to="/contact">Contact Us</Link>
                            <Link className="btn btn-link" to="/privacy_policy">Privacy Policy</Link>
                            <Link className="btn btn-link" to="/terms_and_conditions">Terms & Condition</Link>
                            <Link className="btn btn-link" to="">FAQs & Help</Link>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <h4 className="text-white mb-3">Contact</h4>
                            <p className="mb-2"><i className="fa fa-map-marker-alt me-3"></i>{ContactDetail.door_no}, {ContactDetail.street},</p>
                            <p className="mb-2"><i className="fa fa-map-marker-alt me-3"></i>{ContactDetail.city}, {ContactDetail.district},</p>
                            <p className="mb-2"><i className="fa fa-map-marker-alt me-3"></i>{ContactDetail.state}, {ContactDetail.country},{ContactDetail.pincode} </p>
                            <p className="mb-2"><i className="fa fa-phone-alt me-3"></i>{ContactDetail.contact_no}</p>
                            <p className="mb-2"><i className="fa fa-envelope me-3"></i>{ContactDetail.email}</p>
                            <div className="d-flex pt-2">
                                <Link className="btn btn-outline-light btn-social" to={ContactDetail.twitter}><i className="fab fa-twitter"></i></Link>
                                <Link className="btn btn-outline-light btn-social" to={ContactDetail.facebook}><i className="fab fa-facebook-f"></i></Link>
                                <Link className="btn btn-outline-light btn-social" to={ContactDetail.youtube}><i className="fab fa-youtube"></i></Link>
                                <Link className="btn btn-outline-light btn-social" to={ContactDetail.linkedin}><i className="fab fa-linkedin-in"></i></Link>
                                <Link className="btn btn-outline-light btn-social" to={ContactDetail.instagram}><i className="fab fa-instagram"></i></Link>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <h4 className="text-white mb-3">Gallery</h4>
                            <div className="row g-2 pt-2">
                                <div className="col-4">
                                    <img className="img-fluid bg-light p-1" src="assets/img/course-1.jpg" alt="" />
                                </div>
                                <div className="col-4">
                                    <img className="img-fluid bg-light p-1" src="assets/img/course-2.jpg" alt="" />
                                </div>
                                <div className="col-4">
                                    <img className="img-fluid bg-light p-1" src="assets/img/course-3.jpg" alt="" />
                                </div>
                                <div className="col-4">
                                    <img className="img-fluid bg-light p-1" src="assets/img/course-2.jpg" alt="" />
                                </div>
                                <div className="col-4">
                                    <img className="img-fluid bg-light p-1" src="assets/img/course-3.jpg" alt="" />
                                </div>
                                <div className="col-4">
                                    <img className="img-fluid bg-light p-1" src="assets/img/course-1.jpg" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <h4 className="text-white mb-3">Newsletter</h4>
                            <p>Dolor amet sit justo amet elitr clita ipsum elitr est.</p>
                            <div className="position-relative mx-auto" style={{ width: '400px' }}>
                                <form id="newsLtrFrm" method="post">
                                    <input className="form-control border-0 w-100 py-3 ps-4 pe-5" name="emails" type="email" placeholder="Your email" />
                                    <button type="submit" className="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2">SignUp</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="copyright">
                        <div className="row">
                            <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                                &copy; <Link className="border-bottom" to="#">Alumni Portal</Link>, All Right Reserved.


                                Designed By <Link className="border-bottom" to=""> GET IN Technology</Link>
                            </div>
                            <div className="col-md-6 text-center text-md-end">
                                <div className="footer-menu">
                                    <Link to="/">Home</Link>
                                    <Link to="/cookies">Cookies</Link>
                                    <Link to="">Help</Link>
                                    <Link to="">FQAs</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Footer End --> */}


            {/* <!-- Back to Top --> */}
            <button
                className="btn btn-lg btn-primary btn-lg-square back-to-top"
                onClick={scrollToTop}
                style={{ display: visible ? 'inline' : 'none', position: 'fixed', bottom: '20px', right: '20px', zIndex: 1000, borderRadius: '25px' }}
                aria-label="Back to top"
            >
                <i className="bi bi-arrow-up"></i>
            </button>
        </>
    );
}

export default Footer;